/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from '@sainsburys-tech/bolt';
import { canUseDom } from '@sainsburys-tech/boltui-utils';
import { HeaderContext, Fallback } from './components';
/* Express middleware to be consumed within applications */

export { headerMiddleware, headerProxy } from './utils';
/* Header Provider & Context */

export { HeaderProvider, HeaderContext, GetHeaderBundle, GetHeaderStyles } from './components';
var propTypes = {
  miniHeader: PropTypes.bool,
  miniHeaderContent: PropTypes.element,
  routes: PropTypes.shape({
    help: PropTypes.func,
    stores: PropTypes.func,
    search: PropTypes.func,
    megabuttons: PropTypes.arrayOf(PropTypes.func)
  }),
  overrideSearchTerm: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  overrideTrolleyCount: PropTypes.number,
  overrideWishlistCount: PropTypes.oneOfType([PropTypes.number, PropTypes.element]),
  overrideOnSearchSubmit: PropTypes.func,
  onUserInfoLoad: PropTypes.func,
  onCisCookieCreated: PropTypes.func,
  trolleyCountChange: PropTypes.number
};
var defaultProps = {
  miniHeader: false,
  miniHeaderContent: null,
  routes: {},
  overrideTrolleyCount: null,
  overrideWishlistCount: null,
  onUserInfoLoad: function onUserInfoLoad() {
    return {};
  },
  onCisCookieCreated: function onCisCookieCreated() {
    return false;
  },
  trolleyCountChange: 0,
  storeId: 10151,
  langId: 110,
  catalogId: 10001
};

var ArgosHeader = function ArgosHeader(props) {
  var Header = global.argosHeaderService && global.argosHeaderService.component;
  /* Server side & server side fallback */

  if (!canUseDom()) {
    return /*#__PURE__*/React.createElement(HeaderContext.Consumer, null, function (value) {
      return value ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: value.html
        }
      }) : /*#__PURE__*/React.createElement(Fallback, null);
    });
  }
  /* Client side fallback */


  if (canUseDom() && (!Header || typeof Header !== 'function')) {
    return /*#__PURE__*/React.createElement(Fallback, null);
  }
  /* Client side */


  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: /*#__PURE__*/React.createElement(Fallback, null)
  }, /*#__PURE__*/React.createElement(Header, props));
};

ArgosHeader.propTypes = propTypes;
ArgosHeader.defaultProps = defaultProps;
export default ArgosHeader;
export { ArgosHeader };